export const createBearAuthedHeader = (token: string): string => {
  return `Bearer ${token}`;
};
